// extracted by mini-css-extract-plugin
export default {"btnsHide":"BtnsLessons_btnsHide__WrhVm","btnsLessonsContainer":"BtnsLessons_btnsLessonsContainer__JOncy","button":"BtnsLessons_button__UG+a6"};